import { render } from "./Collab.vue?vue&type=template&id=16e03e75&ts=true"
import script from "./Collab.vue?vue&type=script&lang=ts"
export * from "./Collab.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__